const blockUrl = `{
  "reject_requests": ["someurl.com/style.css"]
}`;

export default blockUrl;
